import { createSlice } from '@reduxjs/toolkit';

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState: {
    open: false,
    title: '',
    subtitle: '',
    duration: 6000,
    severity: 'success', // default severity
    position: { vertical: 'top', horizontal: 'center' },
  },
  reducers: {
    openSnackbar: (state, action) => {
      const { title, subtitle, duration, severity, position } = action.payload;
      state.open = true;
      state.title = title;
      state.subtitle = subtitle;
      state.duration = duration;
      state.severity = severity; // Update severity in state
      state.position = position || { vertical: 'top', horizontal: 'right' };
    },
    closeSnackbar: (state) => {
      state.open = false;
      state.title = '';
      state.subtitle = '';
      state.severity = ''; // Reset to default severity
    },
    showSuccessSnackbar: (state, action) => {
      const { title, subtitle, duration, position } = action.payload;
      state.open = true;
      state.title = title;
      state.subtitle = subtitle || '';
      state.duration = duration || 4000;
      state.severity = 'success';
      state.position = position || { vertical: 'top', horizontal: 'right' };
    },
    showErrorSnackbar: (state, action) => {
        const { title, subtitle, duration, position } = action.payload;
        state.open = true;
        state.title = title;
        state.subtitle = subtitle || '';
        state.duration = duration || 4000;
        state.severity = 'error';
        state.position = position || { vertical: 'top', horizontal: 'right' };
    },
  },
});

// Export actions
export const { openSnackbar, closeSnackbar, showSuccessSnackbar, showErrorSnackbar } = snackbarSlice.actions;

// Export reducer
export default snackbarSlice.reducer;
